import { render, staticRenderFns } from "./MultaZofemat.vue?vue&type=template&id=d0db5b00&"
import script from "./MultaZofemat.vue?vue&type=script&lang=ts&"
export * from "./MultaZofemat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports